<div>
    <ul class="tabs" role="tablist">     
        <li>
            <input type="radio" name="tabs" id="tab1"  checked />
            <label for="tab1" role="tab" aria-selected="true" aria-controls="panel1" tabindex="0">Rapid - Incomplete
                Application<br />
                <span class="totalRowPipeline">[{{ rapidIncompleteCount }}] {{ rapidIncompleteAmount | currency
                    }}</span>
            </label>
            <div id="tab-content1" class="tab-content" role="tabpanel" aria-labelledby="description"
                aria-hidden="false">
                <table class="table table-bordered table-hover">
                    <thead>
                        <tr>
                            <th *ngFor="let item of displayedColumns">
                                {{item}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of rapidIncomplete">
                            <td><a class="noline" target="_self" [routerLink]="['/applications/summary', item.id]"
                                    [queryParams]="{ dealname: item.Deal_Name }">{{ item.Deal_Name
                                    }}</a></td>
                            <td>{{item?.Agency_Formula}}</td>
                            <td>{{item?.Collector_Formula}}</td>
                            <td>{{item?.Creditt}}</td>
                            <td>{{$safeNavigationMigration(item?.Agency_Amount) | currency}}</td>
                            <td>{{item?.Province}}</td>
                            <td>{{item?.Created_By}}</td>
                            <td>{{item?.Created_Time}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </li>

        <li>
            <input type="radio" name="tabs" id="tab2" />
            <label for="tab2" role="tab" aria-selected="true" aria-controls="panel2" tabindex="1">Rapid -
                Underwriting<br />
                <span class="totalRowPipeline">[{{ rapidUnderwritingCount }}] {{ rapidUnderwritingAmount | currency
                    }}</span>
            </label>
            <div id="tab-content2" class="tab-content" role="tabpanel" aria-labelledby="description"
                aria-hidden="false">
                <table class="table table-bordered table-hover">
                    <thead>
                        <tr>
                            <th *ngFor="let item of displayedColumns">
                                {{item}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of rapidUnderwriting">
                            <td><a class="noline" target="_self" [routerLink]="['/applications/summary', item.id]"
                                    [queryParams]="{ dealname: item.Deal_Name }">{{ item.Deal_Name
                                    }}</a></td>
                            <td>{{item?.Agency_Formula}}</td>
                            <td>{{item?.Collector_Formula}}</td>
                            <td>{{item?.Creditt}}</td>
                            <td>{{$safeNavigationMigration(item?.Agency_Amount) | currency}}</td>
                            <td>{{item?.Province}}</td>
                            <td>{{item?.Created_By}}</td>
                            <td>{{item?.Created_Time}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </li>

        <li>
            <input type="radio" name="tabs" id="tab3" />
            <label for="tab3" role="tab" aria-selected="true" aria-controls="panel3" tabindex="2">Rapid -
                Agreement<br />
                <span class="totalRowPipeline">[{{ rapidAgreementCount }}] {{ rapidAgreementAmount | currency
                    }}</span>
            </label>
            <div id="tab-content3" class="tab-content" role="tabpanel" aria-labelledby="description"
                aria-hidden="false">
                <table class="table table-bordered table-hover">
                    <thead>
                        <tr>
                            <th *ngFor="let item of displayedColumns">
                                {{item}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of rapidAgreement">
                            <td><a class="noline" target="_self" [routerLink]="['/applications/summary', item.id]"
                                    [queryParams]="{ dealname: item.Deal_Name }">{{ item.Deal_Name
                                    }}</a></td>
                            <td>{{item?.Agency_Formula}}</td>
                            <td>{{item?.Collector_Formula}}</td>
                            <td>{{item?.Creditt}}</td>
                            <td>{{$safeNavigationMigration(item?.Agency_Amount) | currency}}</td>
                            <td>{{item?.Province}}</td>
                            <td>{{item?.Created_By}}</td>
                            <td>{{item?.Created_Time}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </li>

        <li>
            <input type="radio" name="tabs" id="tab4" />
            <label for="tab4" role="tab" aria-selected="true" aria-controls="panel4" tabindex="3">Rapid - Approved<br />
                <span class="totalRowPipeline">[{{ rapidApprovedCount }}] {{ rapidApprovedAmount | currency
                    }}</span>
            </label>
            <div id="tab-content4" class="tab-content" role="tabpanel" aria-labelledby="description"
                aria-hidden="false">
                <table class="table table-bordered table-hover">
                    <thead>
                        <tr>
                            <th *ngFor="let item of displayedColumns">
                                {{item}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of rapidApproved">
                            <td><a class="noline" target="_self" [routerLink]="['/applications/summary', item.id]"
                                    [queryParams]="{ dealname: item.Deal_Name }">{{ item.Deal_Name
                                    }}</a></td>
                            <td>{{item?.Agency_Formula}}</td>
                            <td>{{item?.Collector_Formula}}</td>
                            <td>{{item?.Creditt}}</td>
                            <td>{{$safeNavigationMigration(item?.Agency_Amount) | currency}}</td>
                            <td>{{item?.Province}}</td>
                            <td>{{item?.Created_By}}</td>
                            <td>{{item?.Created_Time}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </li>
        <li>
            <input type="radio" name="tabs" id="tab5"/>
            <label for="tab5" role="tab" aria-selected="true" aria-controls="panel5" tabindex="4">Funded<br />
                <mat-spinner *ngIf="spinner === true" diameter="15"></mat-spinner>
                <span class="totalRowPipeline" *ngIf="spinner === false">[{{ rapidFundedCount }}] {{ rapidFundedAmount | currency }}</span>
            </label>
            <div id="tab-content5" class="tab-content" role="tabpanel" aria-labelledby="description"
                aria-hidden="false">
                <table class="table table-bordered table-hover">
                    <thead>
                        <tr>
                            <th *ngFor="let item of displayedColumns">
                                {{item}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of rapidFunded">
                            <td><a class="noline" target="_self" [routerLink]="['/applications/summary', item.id]"
                                    [queryParams]="{ dealname: item.Deal_Name }">{{ item.Deal_Name
                                    }}</a></td>
                            <td>{{item?.Agency_Formula}}</td>
                            <td>{{item?.Collector_Formula}}</td>
                            <td>{{item?.Creditt}}</td>
                            <td>{{$safeNavigationMigration(item?.Amount) | currency}}</td>
                            <td>{{item?.Province}}</td>
                            <td>{{item?.Created_By}}</td>
                            <td>{{item?.Created_Time}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </li>
    </ul>
</div>